/* global axios */
import ApiClient from './ApiClient';

class CustomerRequestsAPI extends ApiClient {
  constructor() {
    super('customer_requests', { accountScoped: true });
  }

  // Supported params: status, channel, inbox_id, assignee ('me'), q, page
  getRequests(params = {}) {
    return axios.get(this.url, { params });
  }

  getMeta() {
    return axios.get(`${this.url}/meta`);
  }

  claim(id) {
    return axios.post(`${this.url}/${id}/claim`);
  }
}

export default new CustomerRequestsAPI();
